/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TierType = "CORE" | "ENTERPRISE" | "FREE_FOREVER" | "LITE" | "PRO" | "TRIAL" | "%future added value";
export type settingsAppCatalog_viewer = {
    readonly company: {
        readonly tier: TierType | null;
        readonly " $fragmentRefs": FragmentRefs<"ToggleIsSSOMandatory_company">;
    } | null;
    readonly " $refType": "settingsAppCatalog_viewer";
};
export type settingsAppCatalog_viewer$data = settingsAppCatalog_viewer;
export type settingsAppCatalog_viewer$key = {
    readonly " $data"?: settingsAppCatalog_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"settingsAppCatalog_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "settingsAppCatalog_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ToggleIsSSOMandatory_company"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = 'a5c89931768d7ade2a2d029ee8c1ae00';
export default node;
